<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'

useSeoMeta({
  title: 'Инфографика для маркетплейсов онлайн – Magvi',
  description: 'Бесплатная программа, в которой можно удалить фон, добавить ' +
    'подходящие иконки, выбрать готовую инфографику из шаблонов и отредактировать ее.',
})

const toMatch = [
  /Android/i,
  /webOS/i,
  /iPhone/i,
  /iPad/i,
  /iPod/i,
  /BlackBerry/i,
  /Windows Phone/i,
]

const canShare = toMatch.some((toMatchItem) => {
  return !process.server && navigator.userAgent.match(toMatchItem)
})

const share = () => {
  if (canShare) {
    navigator.share({ url: useRuntimeConfig().public.appUrl })
  }
}

</script>

<template>
  <div class="container">
    <div class="d-flex align-items-center flex-column">
      <div class="content-mobile">
        <ClientOnly>
          <div class="video-container mb-3">
            <iframe
              id="player"
              type="text/html"
              width="100%"
              height="340"
              videoId="player"
              allow="fullscreen"
              frameborder="0"
              :src="'https://www.youtube.com/embed/YI1fjqHPg8o?' +
                'enablejsapi=1&autoplay=1&controls=0&disablekb=1&loop=1&rel=0&showinfo=0&mute=1&playlist=YI1fjqHPg8o'"
            />
          </div>
        </ClientOnly>
        <h3 class="fs-5">
          Создать инфографику можно только на ПК
        </h3>
        <p class="mb-4">
          Мы работаем над мобильной версией. Попробуйте зайти на сайт с компьютера.
        </p>
        <AButton
          v-if="canShare"
          class="w-100 mt-auto"
          :button-style="ButtonStyle.Primary"
          @click.prevent="share"
        >
          <BootstrapIconBoxArrowUp />
          Поделиться ссылкой
        </AButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content {
  position: relative;
  margin-top: rem(85px);

  @include media-breakpoint-down(xl) {
    display: none;
  }
}

.content-mobile {
  max-width: rem(642px);

  @include media-breakpoint-up(xl) {
    display: none;
  }

  img {
    border: 1px solid #DEE2E6;
  }
}

.arrow-right {
  position: absolute;
  top: 30px;
  left: 0;
  color: $indigo-500;
}

.card-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: rem(20px);
  padding: rem(136px) rem(148px) rem(136px) rem(148px);
  background-color: #F5EFFF;
  border-radius: rem(32px);
  cursor: pointer;
}

.home-img:not(:last-child) {
  margin-right: rem(12px);
}

.video-container {
  border: 1px solid #DEE2E6;
  position: relative;
  overflow: hidden;
  width: 100%;

  &::after {
    content: "";
    display: block;
    padding-top: 56.25%;
  }

  iframe, video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
